import { render } from "./NoAutorizadoViews.vue?vue&type=template&id=9ba97ee0&scoped=true"
import script from "./NoAutorizadoViews.vue?vue&type=script&lang=js"
export * from "./NoAutorizadoViews.vue?vue&type=script&lang=js"

import "./NoAutorizadoViews.vue?vue&type=style&index=0&id=9ba97ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba97ee0"]])

export default __exports__